import Vue from 'vue'
import VueResource from 'vue-resource'
import mixins from '../mixins.js'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import RingLoader from 'vue-spinner/src/RingLoader.vue'

if ($('#test_form').length) {
  Vue.use(VueResource)
  new Vue({
    el: '#test_form',
    components: {
      Multiselect,
      RingLoader
    },
    mixins: [mixins],
    data: {
      loading: 0,
      multimedia: [],
      form: {
        entity: {
          companies: [],
          selectedCompanies : [1]
        },
        options: {
          companies: [{ id : 1,
            name : 'Apator' }, { id:2,
            name:'Elana' }],
          errors: {},
        }
      },

    },

    mounted() {

    },
    methods: {

    }
  })
}
